const getSubdivisions = (
  opp: EBattleGameOpponent | undefined,
  slug: EBattleColumnarSlug
): EBattleSubdivision[] => {
  if (!opp) return [];
  const oppAny = opp as Record<string, any>;
  switch (slug) {
    case 'e-basketball':
      return oppAny.quarters ?? [];
    case 'e-hockey':
      return oppAny.periods ?? [];
  }
};

const getSubdivisionScore = (
  opp: EBattleGameOpponent | undefined,
  slug: EBattleColumnarSlug,
  index: number
): number | null => {
  const subs = getSubdivisions(opp, slug);
  const sub = subs.find(s => s.index === index);
  return sub ? sub.score : null;
};

const getCurrentSubdivision = (
  game: MatchGame | undefined,
  slug: EBattleColumnarSlug
): number | null => {
  if (!game) return null;
  switch (slug) {
    case 'e-basketball':
      return game.current_quarter ?? null;
    case 'e-hockey':
      return game.current_period ?? null;
  }
};

export { getSubdivisions, getSubdivisionScore, getCurrentSubdivision };
